import { Component } from '@angular/core';

import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { LexiconModule } from '@galaxy/lexicon';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import {
  PARTNER_GOOGLE_MEET_INTEGRATION_ID_DEMO,
  PARTNER_GOOGLE_MEET_INTEGRATION_ID_PROD,
} from '@galaxy/platform-integrations/shared';
import { Environment, EnvironmentService } from '@galaxy/core';

@Component({
  imports: [
    GalaxyPageModule,
    LexiconModule,
    GalaxyEmptyStateModule,
    MatCardModule,
    MatButtonModule,
    RouterLink
],
  templateUrl: './sales-coach-config-page.component.html',
  styleUrl: './sales-coach-config-page.component.scss',
  standalone: true,
})
export class SalesCoachConfigPageComponent {
  connectionLink =
    this.environmentService.getEnvironment() === Environment.DEMO
      ? ['/integrations/' + PARTNER_GOOGLE_MEET_INTEGRATION_ID_DEMO]
      : ['/integrations/' + PARTNER_GOOGLE_MEET_INTEGRATION_ID_PROD];

  constructor(private readonly environmentService: EnvironmentService) {}
}
